import React, { useCallback, useState } from 'react';

import { yupResolver } from '@hookform/resolvers/yup';
import { useRecordModal } from 'hooks/useRecordModal';
import { useCreateRelatedRequestsBankOps } from 'pages/Finance/RequestsBankOps/hooks/useCreateRelatedRequestsBankOps';
import { useCreateRequestsBankOps } from 'pages/Finance/RequestsBankOps/hooks/useCreateRequestsBankOps';
import { BANK_OPERATION_SCHEMA } from 'pages/Finance/RequestsBankOps/schemas/schema';
import { SimpleForm } from 'react-admin';
import { FieldValues } from 'react-hook-form';
import { Box } from 'shared/mui/Box/Box';
import { CancelButton, SaveButton } from 'shared/mui/Buttons';
import { CardActionsButtons } from 'shared/mui/Card';
import { CreatePage } from 'shared/react-admin/Pages/CreatePage/CreatePage';
import { BankOperation } from 'types/embedded/bankOperation';

import { RequestsBankOpsCreateForm } from './RequestsBankOpsCreateForm';
import { RequestsBankOpsCreateSuccessDialog } from './RequestsBankOpsCreateSuccessDialog/RequestsBankOpsCreateSuccessDialog';

export const RequestsBankOpsCreate: React.FC = () => {
  const { handleOpenRecordModal, openRecordModal, record, handleCloseRecordModal } =
    useRecordModal<BankOperation>();
  const [errors, setErrors] = useState();

  const { createRelatedRequestsBankOps } = useCreateRelatedRequestsBankOps(
    handleOpenRecordModal,
    setErrors,
  );
  const { createRequestsBankOps } = useCreateRequestsBankOps(handleOpenRecordModal, setErrors);
  const [isRelated, setIsRelated] = useState(false);

  const handleSubmit = useCallback(
    (data: FieldValues) => {
      return isRelated
        ? createRelatedRequestsBankOps(data as BankOperation)
        : createRequestsBankOps(data as BankOperation);
    },
    [isRelated],
  );

  return (
    <CreatePage
      listName="Заявки на банковскую операцию"
      mutationOptions={{}}
      title="Создание заявки на банковскую операцию"
    >
      <SimpleForm
        noValidate
        onSubmit={handleSubmit}
        resolver={yupResolver<FieldValues>(BANK_OPERATION_SCHEMA)}
        shouldUseNativeValidation={false}
        sx={{ '&.MuiCardContent-root': { padding: 0 } }}
        toolbar={false}
      >
        <Box sx={{ padding: '24px 0 4px', width: '100%' }}>
          <RequestsBankOpsCreateForm
            errors={errors}
            isRelated={isRelated}
            setIsRelated={setIsRelated}
          />
        </Box>
        <CardActionsButtons
          rightActionsSlot={[
            <CancelButton key="cancel-button" linkType="back" variant="outlined" />,
            <SaveButton key="save-button" />,
          ]}
          sx={{ marginTop: 'auto', padding: 0 }}
        />
      </SimpleForm>
      <RequestsBankOpsCreateSuccessDialog
        onClose={handleCloseRecordModal}
        open={openRecordModal}
        record={record}
      />
    </CreatePage>
  );
};
